<template>
  <div class="userandpswsetup">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>账号密码</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img width="16px" height="16px" src="@/assets/house/refresh.png" alt="">
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <h4>账号密码</h4>
      <div class="upbg">
        <div style="width:600px;">
          <el-upload
            class="avatar-uploader"
            action="https://httpbin.org/post"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

          <br>

          <el-upload
            class="upload-demo"
            action="https://httpbin.org/post"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="3"
            :show-file-list="false"
            :on-exceed="handleExceed"
            :on-success="fileSuccess"
            >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>

          <br>

          
          <el-upload
            class="upload-demo"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :http-request="handleRequest"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>

          <br>


          <img :src="src" alt="">
          
        </div>
      </div>

      
    </div>


  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import getMD5 from '@/plugins/getMD5'
export default {
  components:{

  },
  data() {
      return {
        imageUrl: '',
        fileList: [],
        src:''
      };
    },
    methods: {

      //h5 input文件上传
      getFileContent(){
        var fileReader = new FileReader();
        var dataFile = this.$refs.myFile.files[0];
        const _this = this
        var spark = new SparkMD5(); //创建md5对象（基于SparkMD5）
        // fileReader.readAsBinaryString(dataFile);
        if (dataFile.size > 1024 * 1024*10) {
          var data1 = dataFile.slice(0, 1024 * 1024*10); //将文件进行分块 file.slice(start,length)
          fileReader.readAsBinaryString(data1); //将文件读取为二进制码
        } else {
          fileReader.readAsBinaryString(dataFile);
        }

        //文件读取完毕之后的处理
        //a639e28526d1809745b46bf1189594fe  6d9efe0c593b1383482feb229318e03a
        fileReader.onload = function(e) {
          // console.log(e)
          spark.appendBinary(e.target.result);
          var md5 = spark.end()
          // console.log(md5)
          // _this.getMd5Checked(md5)
        };
      },

      //文件
      handleRemove(file, fileList) {
        // console.log(file, fileList);
      },
      handlePreview(file) {
        // console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`,{
          confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
        });
      },
      handleRequest(param){
        const file = param.file,
            fileType = file.type,
            isImage = fileType.indexOf("image") != -1,
            isLt2M = file.size / 1024 / 1024 < 2;
        if (!isImage) {
          this.$message.error("只能上传图片格式png、jpg、gif!");
          return false;
        }
        if (!isLt2M) {
          this.$message.error("只能上传图片大小小于2M");
          return false;
        }
        getMD5(file,md5 => {
          // console.log(md5)
        })
      },
      fileSuccess(response, file, fileList){
        // console.log(response, file, fileList)
        // this.src = response.files.file
        // var fileReader = new FileReader();
        // var dataFile = fileList[0];
        // const _this = this
        // var spark = new SparkMD5(); //创建md5对象（基于SparkMD5）
        // fileReader.readAsBinaryString(dataFile);
        // fileReader.onload = function(e) {
        //   spark.appendBinary(e.target.result);
        //   var md5 = spark.end()
        // };
        // let MD5list = getMD5(fileList)
        // console.log('上传成功 ')
      },
      //图片
      handleAvatarSuccess(response, file, fileList) {
        // this.uploadFile(fileList[0].raw, () => {
        //     // upload-success
        //     console.log(1)
        // })

        let MD5list = getMD5(fileList)
        console.log(MD5list[0])
        // this.imageUrl = URL.createObjectURL(file.raw);
        // console.log(response, file,fileList)
        // var fileReader = new FileReader();
        // var dataFile = fileList[0].raw;
        // const _this = this
        // var spark = new SparkMD5(); //创建md5对象（基于SparkMD5）
        // // fileReader.readAsBinaryString(dataFile);
        // if (dataFile.size > 1024 * 1024*10) {
        //   var data1 = dataFile.slice(0, 1024 * 1024*10); //将文件进行分块 file.slice(start,length)
        //   fileReader.readAsBinaryString(data1); //将文件读取为二进制码
        // } else {
        //   fileReader.readAsBinaryString(dataFile);
        // }

        // //文件读取完毕之后的处理
        // //a639e28526d1809745b46bf1189594fe  6d9efe0c593b1383482feb229318e03a
        // fileReader.onload = function(e) {
        //   console.log(e)
        //   spark.appendBinary(e.target.result);
        //   var md5 = spark.end()
        //   console.log(md5)
          
        // };
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }

    },
    mounted(){
      
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./userandpswsetup.scss";

h4{
  font-size: 18px;
}


</style>
